import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Combobox, Label } from '@massilia/ui';
import { useFieldContext } from '../hooks/use-app-form.js';
import { FieldError } from './field-error';
const STABLE_ARRAY = [];
export default function MultiSelectAutocompleteField({ disabled, emptyMessage, isLoading, label, minSearchLength, onSearchChange, options, placeholder, searchHint, }) {
    const field = useFieldContext();
    const value = field.state.value ?? STABLE_ARRAY;
    const errors = field.state.meta.errors;
    return (_jsxs("div", { className: "flex flex-1 flex-col gap-2", children: [label && _jsx(Label, { className: "text-xs font-medium md:text-sm", children: label }), _jsx(Combobox, { disabled: disabled, emptyMessage: emptyMessage, isLoading: isLoading, minSearchLength: minSearchLength, mode: "multi", onChange: field.handleChange, onSearchChange: onSearchChange, options: options, placeholder: placeholder, searchHint: searchHint, value: value }), _jsx(FieldError, { errors: errors })] }));
}
